export const STRAPI_DOMAIN = `https://weact-strapi.cenergy.io`
export const ATS_STRAPI_DOMAIN = `https://strapi.cenergy.io`
export const API_DOMAIN = `https://weact-api.cenergy.io`
export const GOOGLE_MAP_KEY = 'AIzaSyB5JHOU1dEnP2gnd-p4dxkcwjeioU-JpYI'
export const GOOGLE_RECAPTCHA_SITE_KEY = '6LdYD54lAAAAAGS5nWhrREnwcimDiTVJA9RVh_Tx'
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const NYCHA_BUILDINGS = [
  {
    "value": "1010 EAST 178TH STREET - BRONX",
    "label": "1010 EAST 178TH STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "104-14 TAPSCOTT STREET - BROOKLYN",
    "label": "104-14 TAPSCOTT STREET - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "1162-1176 WASHINGTON AVENUE - BRONX",
    "label": "1162-1176 WASHINGTON AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "131 SAINT NICHOLAS AVENUE - MANHATTAN",
    "label": "131 SAINT NICHOLAS AVENUE - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "1471 WATSON AVENUE - BRONX",
    "label": "1471 WATSON AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "154 WEST 84TH STREET - MANHATTAN",
    "label": "154 WEST 84TH STREET - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "303 VERNON AVENUE - BROOKLYN",
    "label": "303 VERNON AVENUE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "335 EAST 111TH STREET - MANHATTAN",
    "label": "335 EAST 111TH STREET - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "344 EAST 28TH STREET - MANHATTAN",
    "label": "344 EAST 28TH STREET - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "45 ALLEN STREET - MANHATTAN",
    "label": "45 ALLEN STREET - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "572 WARREN STREET - BROOKLYN",
    "label": "572 WARREN STREET - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "830 AMSTERDAM AVENUE - MANHATTAN",
    "label": "830 AMSTERDAM AVENUE - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "ADAMS - BRONX",
    "label": "ADAMS - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "ALBANY - BROOKLYN",
    "label": "ALBANY - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "ALBANY II - BROOKLYN",
    "label": "ALBANY II - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "AMSTERDAM - MANHATTAN",
    "label": "AMSTERDAM - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "AMSTERDAM ADDITION - MANHATTAN",
    "label": "AMSTERDAM ADDITION - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "AREMONT PARKWAY-FRANKLIN AVENUE - BRONX",
    "label": "AREMONT PARKWAY-FRANKLIN AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "ARMSTRONG I - BROOKLYN",
    "label": "ARMSTRONG I - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "ARMSTRONG II - BROOKLYN",
    "label": "ARMSTRONG II - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "ASTORIA - QUEENS",
    "label": "ASTORIA - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "ATLANTIC TERMINAL SITE 4B - BROOKLYN",
    "label": "ATLANTIC TERMINAL SITE 4B - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "AUDUBON - MANHATTAN",
    "label": "AUDUBON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "BAILEY AVENUE-WEST 193RD STREET - BRONX",
    "label": "BAILEY AVENUE-WEST 193RD STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BAISLEY PARK - QUEENS",
    "label": "BAISLEY PARK - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "BARUCH - MANHATTAN",
    "label": "BARUCH - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "BARUCH HOUSES ADDITION - MANHATTAN",
    "label": "BARUCH HOUSES ADDITION - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "BAY VIEW - BROOKLYN",
    "label": "BAY VIEW - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BAYCHESTER - BRONX",
    "label": "BAYCHESTER - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BEACH 41ST STREET-BEACH CHANNEL DRIVE - QUEENS",
    "label": "BEACH 41ST STREET-BEACH CHANNEL DRIVE - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "BEDFORD-STUYVESANT REHAB - BROOKLYN",
    "label": "BEDFORD-STUYVESANT REHAB - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BELMONT-SUTTER AREA - BROOKLYN",
    "label": "BELMONT-SUTTER AREA - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BERRY - STATEN ISLAND",
    "label": "BERRY - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "BERRY STREET-SOUTH 9TH STREET - BROOKLYN",
    "label": "BERRY STREET-SOUTH 9TH STREET - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BETANCES I - BRONX",
    "label": "BETANCES I - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES II, 13 - BRONX",
    "label": "BETANCES II, 13 - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES II, 18 - BRONX",
    "label": "BETANCES II, 18 - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES II, 9A - BRONX",
    "label": "BETANCES II, 9A - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES III, 13 - BRONX",
    "label": "BETANCES III, 13 - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES III, 18 - BRONX",
    "label": "BETANCES III, 18 - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES III, 9A - BRONX",
    "label": "BETANCES III, 9A - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES IV - BRONX",
    "label": "BETANCES IV - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES V - BRONX",
    "label": "BETANCES V - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETANCES VI - BRONX",
    "label": "BETANCES VI - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BETHUNE GARDENS - MANHATTAN",
    "label": "BETHUNE GARDENS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "BLAND - QUEENS",
    "label": "BLAND - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "BORINQUEN PLAZA I - BROOKLYN",
    "label": "BORINQUEN PLAZA I - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BORINQUEN PLAZA II - BROOKLYN",
    "label": "BORINQUEN PLAZA II - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BOSTON ROAD PLAZA - BRONX",
    "label": "BOSTON ROAD PLAZA - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BOSTON SECOR - BRONX",
    "label": "BOSTON SECOR - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BOULEVARD - BROOKLYN",
    "label": "BOULEVARD - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BOYNTON AVENUE REHAB - BRONX",
    "label": "BOYNTON AVENUE REHAB - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BRACETTI PLAZA - MANHATTAN",
    "label": "BRACETTI PLAZA - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "BREUKELEN - BROOKLYN",
    "label": "BREUKELEN - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BREVOORT - BROOKLYN",
    "label": "BREVOORT - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BRONX RIVER - BRONX",
    "label": "BRONX RIVER - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BRONX RIVER ADDITION - BRONX",
    "label": "BRONX RIVER ADDITION - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BROWN - BROOKLYN",
    "label": "BROWN - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BROWNSVILLE - BROOKLYN",
    "label": "BROWNSVILLE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BRYANT AVENUE-EAST 174TH STREET - BRONX",
    "label": "BRYANT AVENUE-EAST 174TH STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "BUSHWICK - BROOKLYN",
    "label": "BUSHWICK - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BUSHWICK II (GROUPS A & C) - BROOKLYN",
    "label": "BUSHWICK II (GROUPS A & C) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BUSHWICK II (GROUPS B & D) - BROOKLYN",
    "label": "BUSHWICK II (GROUPS B & D) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BUSHWICK II CDA (GROUP E) - BROOKLYN",
    "label": "BUSHWICK II CDA (GROUP E) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "BUTLER - BRONX",
    "label": "BUTLER - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CAMPOS PLAZA II - MANHATTAN",
    "label": "CAMPOS PLAZA II - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "CAREY GARDENS - BROOKLYN",
    "label": "CAREY GARDENS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "CARLETON MANOR - QUEENS",
    "label": "CARLETON MANOR - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "CARVER - MANHATTAN",
    "label": "CARVER - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "CASSIDY-LAFAYETTE - STATEN ISLAND",
    "label": "CASSIDY-LAFAYETTE - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "CASTLE HILL - BRONX",
    "label": "CASTLE HILL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CHELSEA - MANHATTAN",
    "label": "CHELSEA - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "CHELSEA ADDITION - MANHATTAN",
    "label": "CHELSEA ADDITION - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "CLAREMONT REHAB (GROUP 2) - BRONX",
    "label": "CLAREMONT REHAB (GROUP 2) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CLAREMONT REHAB (GROUP 3) - BRONX",
    "label": "CLAREMONT REHAB (GROUP 3) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CLAREMONT REHAB (GROUP 4) - BRONX",
    "label": "CLAREMONT REHAB (GROUP 4) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CLAREMONT REHAB (GROUP 5) - BRONX",
    "label": "CLAREMONT REHAB (GROUP 5) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CLASON POINT GARDENS - BRONX",
    "label": "CLASON POINT GARDENS - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CLINTON - MANHATTAN",
    "label": "CLINTON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "COLLEGE AVENUE-EAST 165TH STREET - BRONX",
    "label": "COLLEGE AVENUE-EAST 165TH STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "CONEY ISLAND - BROOKLYN",
    "label": "CONEY ISLAND - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "CONEY ISLAND I (SITE 1B) - BROOKLYN",
    "label": "CONEY ISLAND I (SITE 1B) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "CONEY ISLAND I (SITE 8) - BROOKLYN",
    "label": "CONEY ISLAND I (SITE 8) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "CONEY ISLAND I (SITES 4 & 5) - BROOKLYN",
    "label": "CONEY ISLAND I (SITES 4 & 5) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "CONLON LIHFE TOWER - QUEENS",
    "label": "CONLON LIHFE TOWER - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "COOPER PARK - BROOKLYN",
    "label": "COOPER PARK - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "CORSI HOUSES - MANHATTAN",
    "label": "CORSI HOUSES - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "CROWN HEIGHTS - BROOKLYN",
    "label": "CROWN HEIGHTS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "CYPRESS HILLS - BROOKLYN",
    "label": "CYPRESS HILLS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "DAVIDSON - BRONX",
    "label": "DAVIDSON - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "DE HOSTOS APARTMENTS - MANHATTAN",
    "label": "DE HOSTOS APARTMENTS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "DOUGLASS ADDITION - MANHATTAN",
    "label": "DOUGLASS ADDITION - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "DOUGLASS I - MANHATTAN",
    "label": "DOUGLASS I - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "DOUGLASS II - MANHATTAN",
    "label": "DOUGLASS II - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "DREW-HAMILTON - MANHATTAN",
    "label": "DREW-HAMILTON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "DYCKMAN - MANHATTAN",
    "label": "DYCKMAN - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "EAGLE AVENUE-EAST 163RD STREET - BRONX",
    "label": "EAGLE AVENUE-EAST 163RD STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "EAST 152ND STREET-COURTLANDT AVENUE - BRONX",
    "label": "EAST 152ND STREET-COURTLANDT AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "EAST 165TH STREET-BRYANT AVENUE - BRONX",
    "label": "EAST 165TH STREET-BRYANT AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "EAST 173RD STREET-VYSE AVENUE - BRONX",
    "label": "EAST 173RD STREET-VYSE AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "EAST 180TH STREET-MONTEREY AVENUE - BRONX",
    "label": "EAST 180TH STREET-MONTEREY AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "EAST NEW YORK CITY LINE - BROOKLYN",
    "label": "EAST NEW YORK CITY LINE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "EAST RIVER - MANHATTAN",
    "label": "EAST RIVER - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "EASTCHESTER GARDENS - BRONX",
    "label": "EASTCHESTER GARDENS - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "EDENWALD - BRONX",
    "label": "EDENWALD - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "ELLIOTT - MANHATTAN",
    "label": "ELLIOTT - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "FARRAGUT - BROOKLYN",
    "label": "FARRAGUT - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "FENIMORE-LEFFERTS - BROOKLYN",
    "label": "FENIMORE-LEFFERTS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "FIORENTINO PLAZA - BROOKLYN",
    "label": "FIORENTINO PLAZA - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "FIRST HOUSES - MANHATTAN",
    "label": "FIRST HOUSES - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "FOREST - BRONX",
    "label": "FOREST - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "FORT INDEPENDENCE STREET-HEATH AVENUE - BRONX",
    "label": "FORT INDEPENDENCE STREET-HEATH AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "FORT WASHINGTON AVENUE REHAB - MANHATTAN",
    "label": "FORT WASHINGTON AVENUE REHAB - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "FRANKLIN AVENUE I CONVENTIONAL - BRONX",
    "label": "FRANKLIN AVENUE I CONVENTIONAL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "FRANKLIN AVENUE II CONVENTIONAL - BRONX",
    "label": "FRANKLIN AVENUE II CONVENTIONAL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "FRANKLIN AVENUE III CONVENTIONAL - BRONX",
    "label": "FRANKLIN AVENUE III CONVENTIONAL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "FULTON - MANHATTAN",
    "label": "FULTON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "GARVEY (GROUP A) - BROOKLYN",
    "label": "GARVEY (GROUP A) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "GHBRIDGE REHABS (NELSON AVENUE) - BRONX",
    "label": "GHBRIDGE REHABS (NELSON AVENUE) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "GLEBE AVENUE-WESTCHESTER AVENUE - BRONX",
    "label": "GLEBE AVENUE-WESTCHESTER AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "GLENMORE PLAZA - BROOKLYN",
    "label": "GLENMORE PLAZA - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "GLENWOOD - BROOKLYN",
    "label": "GLENWOOD - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "GOMPERS - MANHATTAN",
    "label": "GOMPERS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "GOWANUS - BROOKLYN",
    "label": "GOWANUS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "GRAMPION - MANHATTAN",
    "label": "GRAMPION - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "GRANT - MANHATTAN",
    "label": "GRANT - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "GRAVESEND - BROOKLYN",
    "label": "GRAVESEND - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "GUN HILL - BRONX",
    "label": "GUN HILL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "HABER - BROOKLYN",
    "label": "HABER - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "HAMMEL - QUEENS",
    "label": "HAMMEL - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "HARBORVIEW TERRACE - MANHATTAN",
    "label": "HARBORVIEW TERRACE - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "HARLEM RIVER - MANHATTAN",
    "label": "HARLEM RIVER - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "HARLEM RIVER II - MANHATTAN",
    "label": "HARLEM RIVER II - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "HARRISON AVENUE REHAB (GROUP A) - BRONX",
    "label": "HARRISON AVENUE REHAB (GROUP A) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "HARRISON AVENUE REHAB (GROUP B) - BRONX",
    "label": "HARRISON AVENUE REHAB (GROUP B) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "HBRIDGE REHABS (ANDERSON AVENUE) - BRONX",
    "label": "HBRIDGE REHABS (ANDERSON AVENUE) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "HERNANDEZ - MANHATTAN",
    "label": "HERNANDEZ - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "HIGHBRIDGE GARDENS - BRONX",
    "label": "HIGHBRIDGE GARDENS - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "HINGTON HEIGHTS REHAB PHASE III (FORT WASHINGTON) - MANHATTAN",
    "label": "HINGTON HEIGHTS REHAB PHASE III (FORT WASHINGTON) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "HOE AVENUE-EAST 173RD STREET - BRONX",
    "label": "HOE AVENUE-EAST 173RD STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "HOLMES TOWERS - MANHATTAN",
    "label": "HOLMES TOWERS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "HOPE GARDENS - BROOKLYN",
    "label": "HOPE GARDENS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "HOWARD - BROOKLYN",
    "label": "HOWARD - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "HOWARD AVENUE - BROOKLYN",
    "label": "HOWARD AVENUE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "HOWARD AVENUE-PARK PLACE - BROOKLYN",
    "label": "HOWARD AVENUE-PARK PLACE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "HUGHES APARTMENTS - BROOKLYN",
    "label": "HUGHES APARTMENTS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "HUNTS POINT AVENUE REHAB - BRONX",
    "label": "HUNTS POINT AVENUE REHAB - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "HYLAN - BROOKLYN",
    "label": "HYLAN - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "INDEPENDENCE - BROOKLYN",
    "label": "INDEPENDENCE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "INGERSOLL - BROOKLYN",
    "label": "INGERSOLL - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "INTERNATIONAL TOWER - QUEENS",
    "label": "INTERNATIONAL TOWER - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "ISAACS - MANHATTAN",
    "label": "ISAACS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "JACKSON - BRONX",
    "label": "JACKSON - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "JEFFERSON - MANHATTAN",
    "label": "JEFFERSON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "JOHNSON - MANHATTAN",
    "label": "JOHNSON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "KING TOWERS - MANHATTAN",
    "label": "KING TOWERS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "KINGSBOROUGH - BROOKLYN",
    "label": "KINGSBOROUGH - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "KINGSBOROUGH EXTENSION - BROOKLYN",
    "label": "KINGSBOROUGH EXTENSION - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "LA GUARDIA - MANHATTAN",
    "label": "LA GUARDIA - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LA GUARDIA ADDITION - MANHATTAN",
    "label": "LA GUARDIA ADDITION - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LAFAYETTE - BROOKLYN",
    "label": "LAFAYETTE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "LATIMER GARDENS - QUEENS",
    "label": "LATIMER GARDENS - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "LEAVITT STREET-34TH AVENUE - QUEENS",
    "label": "LEAVITT STREET-34TH AVENUE - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "LEHMAN VILLAGE - MANHATTAN",
    "label": "LEHMAN VILLAGE - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LENOX ROAD-ROCKAWAY PARKWAY - BROOKLYN",
    "label": "LENOX ROAD-ROCKAWAY PARKWAY - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "LEXINGTON - MANHATTAN",
    "label": "LEXINGTON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LINCOLN - MANHATTAN",
    "label": "LINCOLN - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LINDEN - BROOKLYN",
    "label": "LINDEN - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "LONG ISLAND BAPTIST HOUSES - BROOKLYN",
    "label": "LONG ISLAND BAPTIST HOUSES - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "LONGFELLOW AVENUE REHAB - BRONX",
    "label": "LONGFELLOW AVENUE REHAB - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "LOW HOUSES - BROOKLYN",
    "label": "LOW HOUSES - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "LOWER EAST SIDE I INFILL - MANHATTAN",
    "label": "LOWER EAST SIDE I INFILL - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LOWER EAST SIDE II - MANHATTAN",
    "label": "LOWER EAST SIDE II - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LOWER EAST SIDE III - MANHATTAN",
    "label": "LOWER EAST SIDE III - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "LOWER EAST SIDE REHAB (GROUP 5) - MANHATTAN",
    "label": "LOWER EAST SIDE REHAB (GROUP 5) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "MANHATTANVILLE - MANHATTAN",
    "label": "MANHATTANVILLE - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "MANHATTANVILLE REHAB (GROUP 2) - MANHATTAN",
    "label": "MANHATTANVILLE REHAB (GROUP 2) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "MANHATTANVILLE REHAB (GROUP 3) - MANHATTAN",
    "label": "MANHATTANVILLE REHAB (GROUP 3) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "MARBLE HILL - BRONX",
    "label": "MARBLE HILL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MARCY - BROOKLYN",
    "label": "MARCY - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "MARCY AVENUE-GREENE AVENUE SITE A - BROOKLYN",
    "label": "MARCY AVENUE-GREENE AVENUE SITE A - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "MARCY AVENUE-GREENE AVENUE SITE B - BROOKLYN",
    "label": "MARCY AVENUE-GREENE AVENUE SITE B - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "MARINER’S HARBOR - STATEN ISLAND",
    "label": "MARINER’S HARBOR - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "MARLBORO - BROOKLYN",
    "label": "MARLBORO - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "MARSHALL PLAZA - MANHATTAN",
    "label": "MARSHALL PLAZA - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "MCKINLEY - BRONX",
    "label": "MCKINLEY - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MELROSE - BRONX",
    "label": "MELROSE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MELTZER TOWER - MANHATTAN",
    "label": "MELTZER TOWER - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "METRO NORTH PLAZA - MANHATTAN",
    "label": "METRO NORTH PLAZA - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "MIDDLETOWN PLAZA - BRONX",
    "label": "MIDDLETOWN PLAZA - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MILL BROOK - BRONX",
    "label": "MILL BROOK - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MILL BROOK EXTENSION - BRONX",
    "label": "MILL BROOK EXTENSION - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MITCHEL - BRONX",
    "label": "MITCHEL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MONROE - BRONX",
    "label": "MONROE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MOORE - BRONX",
    "label": "MOORE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MORRIS I - BRONX",
    "label": "MORRIS I - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MORRIS II - BRONX",
    "label": "MORRIS II - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MORRIS PARK SENIOR CITIZENS HOME - MANHATTAN",
    "label": "MORRIS PARK SENIOR CITIZENS HOME - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "MORRISANIA - BRONX",
    "label": "MORRISANIA - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MORRISANIA AIR RIGHTS - BRONX",
    "label": "MORRISANIA AIR RIGHTS - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MOTT HAVEN - BRONX",
    "label": "MOTT HAVEN - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "MURPHY - BRONX",
    "label": "MURPHY - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "NEW LANE AREA - STATEN ISLAND",
    "label": "NEW LANE AREA - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "NOSTRAND - BROOKLYN",
    "label": "NOSTRAND - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "O’DWYER GARDENS - BROOKLYN",
    "label": "O’DWYER GARDENS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "OCEAN BAY APARTMENTS (BAYSIDE) - QUEENS",
    "label": "OCEAN BAY APARTMENTS (BAYSIDE) - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "OCEAN BAY APARTMENTS (OCEANSIDE) - QUEENS",
    "label": "OCEAN BAY APARTMENTS (OCEANSIDE) - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "OCEAN HILL APARTMENTS - BROOKLYN",
    "label": "OCEAN HILL APARTMENTS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "OCEAN HILL-BROWNSVILLE - BROOKLYN",
    "label": "OCEAN HILL-BROWNSVILLE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "PALMETTO GARDENS - BROOKLYN",
    "label": "PALMETTO GARDENS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "PARK AVENUE-EAST 122ND, 123RD STREETS - MANHATTAN",
    "label": "PARK AVENUE-EAST 122ND, 123RD STREETS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "PARK ROCK REHAB - BROOKLYN",
    "label": "PARK ROCK REHAB - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "PARKSIDE - BRONX",
    "label": "PARKSIDE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "PATTERSON - BRONX",
    "label": "PATTERSON - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "PELHAM PARKWAY - BRONX",
    "label": "PELHAM PARKWAY - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "PENNSYLVANIA AVENUE-WORTMAN AVENUE - BROOKLYN",
    "label": "PENNSYLVANIA AVENUE-WORTMAN AVENUE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "PINK - BROOKLYN",
    "label": "PINK - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "POLO GROUNDS TOWERS - MANHATTAN",
    "label": "POLO GROUNDS TOWERS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "POMONOK - QUEENS",
    "label": "POMONOK - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "PUBLIC SCHOOL 139 (CONVERSION) - MANHATTAN",
    "label": "PUBLIC SCHOOL 139 (CONVERSION) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "QUEENSBRIDGE NORTH - QUEENS",
    "label": "QUEENSBRIDGE NORTH - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "QUEENSBRIDGE SOUTH - QUEENS",
    "label": "QUEENSBRIDGE SOUTH - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "RALPH AVENUE REHAB - BROOKLYN",
    "label": "RALPH AVENUE REHAB - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "RANDALL AVENUE-BALCOM AVENUE - BRONX",
    "label": "RANDALL AVENUE-BALCOM AVENUE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "RANGEL - MANHATTAN",
    "label": "RANGEL - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "RAVENSWOOD - QUEENS",
    "label": "RAVENSWOOD - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "RED HOOK EAST - BROOKLYN",
    "label": "RED HOOK EAST - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "RED HOOK WEST - BROOKLYN",
    "label": "RED HOOK WEST - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "REDFERN - QUEENS",
    "label": "REDFERN - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "REHAB PROGRAM (COLLEGE POINT) - QUEENS",
    "label": "REHAB PROGRAM (COLLEGE POINT) - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "REHAB PROGRAM (DOUGLASS REHABS) - MANHATTAN",
    "label": "REHAB PROGRAM (DOUGLASS REHABS) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "REHAB PROGRAM (TAFT REHABS) - MANHATTAN",
    "label": "REHAB PROGRAM (TAFT REHABS) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "REHAB PROGRAM (WISE REHAB) - MANHATTAN",
    "label": "REHAB PROGRAM (WISE REHAB) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "REID APARTMENTS - BROOKLYN",
    "label": "REID APARTMENTS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "RICHMOND TERRACE - STATEN ISLAND",
    "label": "RICHMOND TERRACE - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "RIIS - MANHATTAN",
    "label": "RIIS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "RIIS II - MANHATTAN",
    "label": "RIIS II - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "ROBBINS PLAZA - MANHATTAN",
    "label": "ROBBINS PLAZA - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "ROBINSON - MANHATTAN",
    "label": "ROBINSON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "ROOSEVELT I - BROOKLYN",
    "label": "ROOSEVELT I - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "ROOSEVELT II - BROOKLYN",
    "label": "ROOSEVELT II - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "RUTGERS - MANHATTAN",
    "label": "RUTGERS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "RUTLAND TOWERS - BROOKLYN",
    "label": "RUTLAND TOWERS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "SACK WERN - BRONX",
    "label": "SACK WERN - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "SAINT MARY’S PARK - BRONX",
    "label": "SAINT MARY’S PARK - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "SAINT NICHOLAS - MANHATTAN",
    "label": "SAINT NICHOLAS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SAMUEL (CITY) - MANHATTAN",
    "label": "SAMUEL (CITY) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SAMUEL (MHOP) I - MANHATTAN",
    "label": "SAMUEL (MHOP) I - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SAMUEL (MHOP) II - MANHATTAN",
    "label": "SAMUEL (MHOP) II - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SAMUEL (MHOP) III - MANHATTAN",
    "label": "SAMUEL (MHOP) III - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SARATOGA VILLAGE - BROOKLYN",
    "label": "SARATOGA VILLAGE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "SEDGWICK - BRONX",
    "label": "SEDGWICK - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "SEWARD PARK EXTENSION - MANHATTAN",
    "label": "SEWARD PARK EXTENSION - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SHEEPSHEAD BAY - BROOKLYN",
    "label": "SHEEPSHEAD BAY - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "SHELTON HOUSE - QUEENS",
    "label": "SHELTON HOUSE - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "SHINGTON HEIGHTS REHAB PHASE III (HARLEM RIVER) - MANHATTAN",
    "label": "SHINGTON HEIGHTS REHAB PHASE III (HARLEM RIVER) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SMITH - MANHATTAN",
    "label": "SMITH - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "SOTOMAYOR HOUSES - BRONX",
    "label": "SOTOMAYOR HOUSES - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "SOUNDVIEW - BRONX",
    "label": "SOUNDVIEW - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "SOUTH BEACH - STATEN ISLAND",
    "label": "SOUTH BEACH - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "SOUTH BRONX AREA (SITE 402) - BRONX",
    "label": "SOUTH BRONX AREA (SITE 402) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "SOUTH JAMAICA I - QUEENS",
    "label": "SOUTH JAMAICA I - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "SOUTH JAMAICA II - QUEENS",
    "label": "SOUTH JAMAICA II - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "STANTON STREET - MANHATTAN",
    "label": "STANTON STREET - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "STAPLETON - STATEN ISLAND",
    "label": "STAPLETON - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "STEBBINS AVENUE-HEWITT PLACE - BRONX",
    "label": "STEBBINS AVENUE-HEWITT PLACE - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "STERLING PLACE REHABS (SAINT JOHNS-STERLING) - BROOKLYN",
    "label": "STERLING PLACE REHABS (SAINT JOHNS-STERLING) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "STERLING PLACE REHABS (STERLING-BUFFALO) - BROOKLYN",
    "label": "STERLING PLACE REHABS (STERLING-BUFFALO) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "STRAUS - MANHATTAN",
    "label": "STRAUS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "STUYVESANT GARDENS I - BROOKLYN",
    "label": "STUYVESANT GARDENS I - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "STUYVESANT GARDENS II - BROOKLYN",
    "label": "STUYVESANT GARDENS II - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "SUMNER - BROOKLYN",
    "label": "SUMNER - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "SURFSIDE GARDENS - BROOKLYN",
    "label": "SURFSIDE GARDENS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "SUTTER AVENUE-UNION STREET - BROOKLYN",
    "label": "SUTTER AVENUE-UNION STREET - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "TAFT - MANHATTAN",
    "label": "TAFT - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "TAPSCOTT STREET REHAB - BROOKLYN",
    "label": "TAPSCOTT STREET REHAB - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "TAYLOR STREET-WYTHE AVENUE - BROOKLYN",
    "label": "TAYLOR STREET-WYTHE AVENUE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "TELLER AVENUE-EAST 166TH STREET - BRONX",
    "label": "TELLER AVENUE-EAST 166TH STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "THOMAS APARTMENTS - MANHATTAN",
    "label": "THOMAS APARTMENTS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "THROGGS NECK - BRONX",
    "label": "THROGGS NECK - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "THROGGS NECK ADDITION - BRONX",
    "label": "THROGGS NECK ADDITION - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "TILDEN - BROOKLYN",
    "label": "TILDEN - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "TODT HILL - STATEN ISLAND",
    "label": "TODT HILL - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "TOMPKINS - BROOKLYN",
    "label": "TOMPKINS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "TWIN PARKS EAST (SITE 9) - BRONX",
    "label": "TWIN PARKS EAST (SITE 9) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "TWIN PARKS WEST (SITES 1 & 2) - BRONX",
    "label": "TWIN PARKS WEST (SITES 1 & 2) - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "TWO BRIDGES URA (SITE 7) - MANHATTAN",
    "label": "TWO BRIDGES URA (SITE 7) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "UNION AVENUE-EAST 163RD STREET - BRONX",
    "label": "UNION AVENUE-EAST 163RD STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "UNION AVENUE-EAST 166TH STREET - BRONX",
    "label": "UNION AVENUE-EAST 166TH STREET - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "UNITY PLAZA (SITES 17,24,25A) - BROOKLYN",
    "label": "UNITY PLAZA (SITES 17,24,25A) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "UNITY PLAZA (SITES 4-27) - BROOKLYN",
    "label": "UNITY PLAZA (SITES 4-27) - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "UNIVERSITY AVENUE REHAB - BRONX",
    "label": "UNIVERSITY AVENUE REHAB - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "UPACA (SITE 5) - MANHATTAN",
    "label": "UPACA (SITE 5) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "UPACA (SITE 6) - MANHATTAN",
    "label": "UPACA (SITE 6) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "VAN DYKE I - BROOKLYN",
    "label": "VAN DYKE I - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "VAN DYKE II - BROOKLYN",
    "label": "VAN DYKE II - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "VANDALIA AVENUE - BROOKLYN",
    "label": "VANDALIA AVENUE - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "VLADECK - MANHATTAN",
    "label": "VLADECK - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "VLADECK II - MANHATTAN",
    "label": "VLADECK II - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WAGNER - MANHATTAN",
    "label": "WAGNER - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WALD - MANHATTAN",
    "label": "WALD - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WASHINGTON - MANHATTAN",
    "label": "WASHINGTON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WASHINGTON HEIGHTS REHAB (GROUPS 1&2) - MANHATTAN",
    "label": "WASHINGTON HEIGHTS REHAB (GROUPS 1&2) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WASHINGTON HEIGHTS REHAB PHASE IV (C) - MANHATTAN",
    "label": "WASHINGTON HEIGHTS REHAB PHASE IV (C) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WASHINGTON HEIGHTS REHAB PHASE IV (D) - MANHATTAN",
    "label": "WASHINGTON HEIGHTS REHAB PHASE IV (D) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WEBSTER - BRONX",
    "label": "WEBSTER - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "WEEKSVILLE GARDENS - BROOKLYN",
    "label": "WEEKSVILLE GARDENS - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "WEST BRIGHTON I - STATEN ISLAND",
    "label": "WEST BRIGHTON I - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "WEST BRIGHTON II - STATEN ISLAND",
    "label": "WEST BRIGHTON II - STATEN ISLAND",
    "borough": "STATEN ISLAND"
  },
  {
    "value": "WEST FARMS ROAD REHAB - BRONX",
    "label": "WEST FARMS ROAD REHAB - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "WEST FARMS SQUARE CONVENTIONAL - BRONX",
    "label": "WEST FARMS SQUARE CONVENTIONAL - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "WEST TREMONT AVENUE-SEDGWICK AVENUE AREA - BRONX",
    "label": "WEST TREMONT AVENUE-SEDGWICK AVENUE AREA - BRONX",
    "borough": "BRONX"
  },
  {
    "value": "WHITE - MANHATTAN",
    "label": "WHITE - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WHITMAN - BROOKLYN",
    "label": "WHITMAN - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "WILLIAMS PLAZA - BROOKLYN",
    "label": "WILLIAMS PLAZA - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "WILLIAMSBURG - BROOKLYN",
    "label": "WILLIAMSBURG - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "WILSON - MANHATTAN",
    "label": "WILSON - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WISE TOWERS - MANHATTAN",
    "label": "WISE TOWERS - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WOODSIDE - QUEENS",
    "label": "WOODSIDE - QUEENS",
    "borough": "QUEENS"
  },
  {
    "value": "WOODSON - BROOKLYN",
    "label": "WOODSON - BROOKLYN",
    "borough": "BROOKLYN"
  },
  {
    "value": "WSUR (BROWNSTONES) - MANHATTAN",
    "label": "WSUR (BROWNSTONES) - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WSUR (SITE A) 120 WEST 94TH STREET - MANHATTAN",
    "label": "WSUR (SITE A) 120 WEST 94TH STREET - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WSUR (SITE B) 74 WEST 92ND STREET - MANHATTAN",
    "label": "WSUR (SITE B) 74 WEST 92ND STREET - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WSUR (SITE C) 589 AMSTERDAM AVENUE - MANHATTAN",
    "label": "WSUR (SITE C) 589 AMSTERDAM AVENUE - MANHATTAN",
    "borough": "MANHATTAN"
  },
  {
    "value": "WYCKOFF GARDENS - BROOKLYN",
    "label": "WYCKOFF GARDENS - BROOKLYN",
    "borough": "BROOKLYN"
  }
]